<template>    
  <div class="content">
    <base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0">Dokumente</h6>
          <nav aria-label="breadcrumb" class="d-none text-black d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Dokumente</h3>
            <p class="text-sm mb-0">
              Nachfolgend finden Sie Dokumente und downloads zur manuellen Verwendung.
            </p>
          </template>
          <div>

                      <!-- b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Anzahl pro Seite" @change="handlePageSizeChange"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Suchen...">
                </base-input>
              </div>
            </b-col -->


<div class="loader" v-if="loading"></div>


    <el-table class="table-responsive align-items-center table-flush table-striped"
              header-row-class-name="thead-light"
              :data="documents">
      <el-table-column label="Nummer"
                       min-width="80px"
                       prop="id"
                       sortable>
                       </el-table-column>
      <el-table-column label="Name"
                       min-width="120px"
                       prop="name"
                       sortable>
                       </el-table-column>
      <el-table-column label="Beschreibung"
                       min-width="200px"
                       prop="description"
                       sortable>
                       </el-table-column>
      <el-table-column label="Erstellt"
                       min-width="140px"
                       sortable>
                       {{ formatDate(created_at) }}
                       </el-table-column>
              <el-table-column min-width="80px" align="right" label="Optionen">
                <div slot-scope="{$index, row}" class="d-flex">
                  <a href="#" class="btn btn-primary btn-sm" @click="downloadFile(documents[$index].id, documents[$index].file.url)"><i class="fas fa-download"></i></a>
                </div>
              </el-table-column>

    </el-table>

</div>









        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="page" :per-page="pageSize" :total="pageCount" @change="handlePageChange"></base-pagination>
        </b-card-footer>

        </card>
      </div>
    </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import LightTable from "../Tables/RegularTables/LightTable";
import { TablePlugin } from 'bootstrap-vue'
import moment from 'moment'


export default {
    components: {
    BasePagination,
    RouteBreadCrumb,
    LightTable,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
  data () {
    return {
      loading: false,
      currentInvoice: null,
      perPage: 1,
      currentPage: 1,
      documents: [],
      count: 0,
      page: 0,
      pageSize: 50,
      pageCount: 50,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: '',
      searchedData: [],
    }
  },
  props: {
    token: String,
    title: "Kundenangebot rechnen",
    icon: "fa-user",
  },
  methods: {
    getRequestParams(searchTitle, page, pageSize) {
      let params = {};

      if (searchTitle) {
        params["internal_id"] = searchTitle;
      }

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["per_page"] = pageSize;
      }

      return params;
    },

    fileNameAndExt(str){
        var file = str.split('/').pop();
        return [file.substr(0,file.lastIndexOf('.')),file.substr(file.lastIndexOf('.')+1,file.length)]
    },

    fileName(str){
        var file = str.split('/').pop();
        return file;
    },

    downloadFile(id, name){
      this.$api.getDocument(id).then(response => {
      console.log(this.fileName(name));
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', this.fileName(name));
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },

    retrieveDocuments() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page,
        this.pageSize
      );
      this.loading = true;
      this.$api.getDocuments(params)
        .then((response) => {
          const { documents, page, page_count, count } = response.data;
          this.documents = documents;
          this.page = page,
          this.pageCount = page_count
          this.count = count;

          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
                        this.loading = false
                    });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveDocuments();
    },

    handlePageSizeChange(value) {
      this.pageSize = value;
      this.page = 1;
      this.retrieveDocuments();
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY")
    }
  },
  computed: {
    searchRegExp () {
      return new RegExp(`(.*)${this.search}(.*)`)
    },
    rows() {
      return this.documents.length;
    },
  },
  created() {
    this.retrieveDocuments();
  },
}
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
<style scoped>
#axiosForm{  /* Components Root Element ID */
    position: relative;
}
.loader{  /* Loader Div Class */
    position: absolute;
    top:0px;
    right:0px; 
    width:100%;
    height:100%;
    background-color:#eceaea;
    background-image: url(/img/custom/ajax-loader.gif);
    background-size: 50px;
    background-repeat:no-repeat;
    background-position:center;
    z-index:10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
</style>